import activeEntityKey from "editor/utils/activeEntityKey";

export default function isActiveEntity(editorState, entity) {
  const contentState = editorState.getCurrentContent();
  // Get the name of the current entity at the beginning of the selection.
  const currentEntityKey = activeEntityKey(editorState);
  const currentEntity = currentEntityKey
    ? contentState.getEntity(currentEntityKey).getType()
    : null;

  return currentEntity === entity;
}
